
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSQuotationGrid extends Serenity.EntityGrid<POSQuotationRow, any> {
        protected getColumnsKey() { return 'Retail.Quotation'; }
        protected getDialogType() { return POSQuotationDialog; }
        protected getIdProperty() { return POSQuotationRow.idProperty; }
        protected getInsertPermission() { return POSQuotationRow.insertPermission; }
        protected getLocalTextPrefix() { return POSQuotationRow.localTextPrefix; }
        protected getService() { return POSQuotationService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);            
        }
        protected addButtonClick() {
            
            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();

            let userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(46);
            this.editItem(<POSQuotationRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 46,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}